export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('table_head_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 90,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_displayLogo') || 'LOGO',
    field: 'displayLogo',
    width: 110,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayLogo' },
  },
  {
    title: that.$l('table_label_custNo') || '客户编号',
    field: 'custNo',
    width: 125,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayName') || '客户名称',
    field: 'displayName',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_custStatus') || '客户状态',
    field: 'custStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'custStatus' },
  },
  {
    title: that.$l('table_label_displayRegion') || '所属国家',
    field: 'displayRegion',
    width: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayRegion' },
  },
  {
    title: that.$l('table_label_displayContact') || '联系方式',
    field: 'displayContact',
    minWidth: 350,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayContact' },
  },
  {
    title: that.$l('table_label_displayProperty') || '客户属性',
    field: 'displayProperty',
    width: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayProperty' },
  },
  {
    title: that.$l('table_label_orgDepFullName') || '业务部门',
    field: 'orgDepFullName',
    minWidth: 350,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
